<svelte:options
        customElement={{
    tag: "ofc-follow-brand-button-v1",
    props: {
      dreson: { type: "String" },
    },
  }}
/>

<script lang="ts">
    import {type BrandApiResponse, type Props} from "./follow-brand-button.types";
    import TrackingService from "./trackingService";

    const SNACKBAR_ID = "follow-brand-button-snackbar";
    const ERROR_SNACKBAR_ID = "follow-brand-button-error-snackbar";

    const trackingService = new TrackingService();

    let {dreson}: Props = $props();
    let isLiked = $state(false)
    let isLoading = $state(false)
    let isLoggedIn = $state(false)

    function handleBrandButtonClick() {
        let payload;
        if (!isLiked) {
            payload = {
                explicitContext: "BRAND",
                payload: dreson,
                action: "ADD",
            };
        } else {
            payload = {
                explicitContext: "BRAND",
                payload: dreson,
                action: "REMOVE",
            };
        }

        isLoading = true;
        fetch('/promo-explicit-api/api/explicit-raw', {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                if (response.ok) {
                    trackingService.emitClickTrackingPayload(!isLiked, dreson)
                    isLiked = !isLiked;
                    openSnackbar()
                } else {
                    openErrorSnackbar();
                }
            })
            .catch(_ => {
                openErrorSnackbar();
            })
            .finally(() => isLoading = false);
    }

    function initializeBrandButton() {
        createSnackbar();
        createErrorSnackbar();
        fetch(`/promo-explicit-api/api/brands/${dreson}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(res => res.json())
            .then((data: BrandApiResponse) => {
                isLiked = data.status === "FOLLOWING";
                isLoggedIn = isLiked || data.status === "NOT_FOLLOWING";
                if (isLoggedIn) {
                    trackingService.emitLoadedTracking(isLiked, dreson, data.totalFollowedBrands)
                }
                return data
            })
    }

    function createSnackbar() {
        const snackbarElement = document.createElement("oc-snackbar-v1");
        snackbarElement.message = "";
        snackbarElement.open = false;
        snackbarElement.id = SNACKBAR_ID;
        snackbarElement.autoDismiss = true;

        const revokeAction = document.createElement('oc-link-v2');
        revokeAction.setAttribute('variant', 'inverted');
        revokeAction.setAttribute('slot', 'actions');
        revokeAction.setAttribute('as-button', 'true');
        revokeAction.setAttribute('oc-aria-label', 'Optionen');
        revokeAction.textContent = 'Rückgängig';
        revokeAction.onclick = () => handleBrandButtonClick();

        snackbarElement.append(revokeAction);
        document.querySelector("ofc-follow-brand-button-v1")!.after(snackbarElement);
    }

    function createErrorSnackbar() {
        const snackbarElement = document.createElement("oc-snackbar-v1");
        snackbarElement.message = "Fehler! Bitte probiere es noch mal.";
        snackbarElement.open = false;
        snackbarElement.id = ERROR_SNACKBAR_ID;
        document.querySelector("ofc-follow-brand-button-v1")!.after(snackbarElement);
    }

    function openSnackbar() {
        const snackbarElement = document.getElementById(SNACKBAR_ID) as any;
        snackbarElement.setAttribute("message", isLiked ? "Gefolgt! Wir zeigen dir mehr Artikel deiner Lieblingsmarke." : "Von deinen Lieblingsmarken entfernt.");
        snackbarElement!.open = true;
    }

    function openErrorSnackbar() {
        const snackbarElement = document.getElementById(ERROR_SNACKBAR_ID) as any;
        snackbarElement.open = true;
    }

    initializeBrandButton();
</script>
{#if isLoggedIn}
    <oc-button-v1 id="follow"
                  size="50"
                  variant="secondary"
                  oc-aria-label={isLiked ? "Folge ich" : "Folgen"}
                  onclick={handleBrandButtonClick}
                  icon-type-left={isLiked ? "check": "plus"}
                  success={isLiked}
                  loading={isLoading}
                  type="button">
        {isLiked ? "Folge ich" : "Folgen"}
    </oc-button-v1>
{/if}